const initialState = {
    isLoading: false,
    validationMsg: '',
};

export default initialState;
